'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMaskedinput = require('react-maskedinput');

var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};

var Glyph = require('./Glyph');

var Input = (function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input(props) {
        _classCallCheck(this, Input);

        _get(Object.getPrototypeOf(Input.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Input';
        this.state = {
            focus: false
        };
    }

    _createClass(Input, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.autofocus) {
                this.focus();
            }
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.refs.input.focus();
            this.setState({ focus: true });
        }
    }, {
        key: 'onFocus',
        value: function onFocus(event) {
            this.setState({
                focus: true
            });

            if (this.props.onFocus) {
                this.props.onFocus(event);
            }
        }
    }, {
        key: 'onBlur',
        value: function onBlur(event) {
            this.setState({
                focus: false
            });

            if (this.props.onBlur) {
                this.props.onBlur(event);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(event) {
            if (this.props.onChange) {
                this.props.onChange(event.target.value, event);
            }
        }
    }, {
        key: 'breakLine',
        value: function breakLine(value) {
            return value.split('\n').reduce(function (prev, curr) {
                prev.push(curr);
                prev.push(_react2['default'].createElement('br'));
                return prev;
            }, []);
        }
    }, {
        key: 'getNotification',
        value: function getNotification(hasError, leftPadding, rightPadding) {
            var _this = this;

            var notification = [];
            var list = function list(item, index) {
                return _react2['default'].createElement(
                    'li',
                    { key: index },
                    item
                );
            };

            var errorIcon = hasError ? _react2['default'].createElement(Glyph, {
                size: 'small',
                type: 'error',
                icon: 'icon-critical-small',
                className: (0, _classnames2['default'])('Input-error-icon'),
                style: {
                    paddingLeft: leftPadding ? leftPadding : null,
                    paddingRight: rightPadding ? rightPadding : null
                }
            }) : null;

            var errors = function errors() {
                return _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])({ 'Input-error': hasError }) },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        _this.props.errors.map(list)
                    )
                );
            };

            var info = function info() {
                return _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])({ 'Input-info': !hasError }) },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        _this.props.info.map(list)
                    )
                );
            };

            var help = function help() {
                return _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])({ 'Input-info': !hasError }) },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        _this.props.help.map(list)
                    )
                );
            };

            notification.push(errorIcon);

            if (this.props.help && this.props.help.length > 0) {
                notification.push(help());
            } else if (this.state.focus && hasError) {
                notification.push(errors());
            } else if (this.state.focus && !hasError && !this.props.value && this.props.info && this.props.info.length > 0) {
                notification.push(info());
            }

            return notification;
        }
    }, {
        key: 'render',
        value: function render() {
            var isBlur = !this.state.focus && !this.props.value,
                hasError = this.props.errors.length,
                className = (0, _classnames2['default'])({
                'Input-readOnly': this.props.readOnly,
                'Input-readOnly--multiline': this.props.readOnly && this.props.multiline,
                Input: !this.props.readOnly,
                error: hasError
            }, this.props.size ? 'Input--' + this.props.size : null, this.props.className),
                hidePlaceholder = isBlur && this.context.type !== 'basic' && this.context.type !== 'horizontal';

            var props = (0, _blacklist2['default'])(this.props, 'onFocus', 'onBlur', 'onChange', 'errors', hidePlaceholder ? 'placeholder' : '');

            var _props = props;
            var leftPadding = _props.leftPadding;
            var rightPadding = _props.rightPadding;

            props = _extends({}, props, {
                className: className,
                ref: 'input',
                onFocus: this.onFocus.bind(this),
                onBlur: this.onBlur.bind(this),
                onChange: this.onChange.bind(this),
                style: {
                    paddingLeft: leftPadding ? leftPadding : null,
                    paddingRight: rightPadding ? hasError ? 'calc(' + rightPadding + ' + 3em)' : rightPadding : hasError ? '3em' : null
                }
            });

            var Element = 'input';

            if (props.readOnly && props.href) {
                Element = 'a';
                props.type = null;
                props.children = props.children || props.value;
            } else if (props.readOnly && props.multiline) {
                Element = 'div';
                props.type = null;
                props.children = props.children || this.breakLine(props.value);
                props.value = null;
            } else if (props.readOnly) {
                Element = 'div';
                props.type = null;
                props.children = props.children || props.value;
            } else if (props.multiline) {
                Element = 'textarea';
            }

            var componentLabel = props.label ? _react2['default'].createElement(
                'label',
                {
                    style: {
                        paddingLeft: leftPadding ? isBlur ? leftPadding : 'calc(' + leftPadding + ' * 1.45)' : null
                    },
                    className: (0, _classnames2['default'])('ComponentLabel', {
                        'ComponentLabel-focus': this.state.focus,
                        'ComponentLabel-blur': isBlur,
                        'ComponentLabel-error': hasError,
                        'ComponentLabel-readOnly': props.readOnly,
                        'ComponentLabel-disabled': props.disabled
                    }),
                    htmlFor: props.id || props.htmlFor
                },
                props.label
            ) : null;

            //Hide MaskedInput pattern placeholder for inline form, when component label shows up.
            if (props.mask && hidePlaceholder) {
                props.placeholder = ' ';
            }

            return _react2['default'].createElement(
                'div',
                {
                    className: (0, _classnames2['default'])('Input-parent', {
                        'Input-parent-focus': this.state.focus
                    })
                },
                componentLabel,
                Element === 'input' && props.mask ? _react2['default'].createElement(_reactMaskedinput2['default'], props) : _react2['default'].createElement(Element, props),
                this.getNotification(hasError, leftPadding, rightPadding)
            );
        }
    }]);

    return Input;
})(_react2['default'].Component);

Input.propTypes = {
    autofocus: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    info: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    help: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    href: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    label: _propTypes2['default'].string,
    leftPadding: _propTypes2['default'].string,
    multiline: _propTypes2['default'].bool,
    name: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func,
    readOnly: _propTypes2['default'].bool,
    rightPadding: _propTypes2['default'].string,
    size: _propTypes2['default'].oneOf(['lg', 'sm', 'xs']),
    type: _propTypes2['default'].string,
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
};

Input.defaultProps = {
    type: 'text',
    errors: [],
    info: [],
    help: []
};

Input.contextTypes = {
    type: _propTypes2['default'].string
};

module.exports = Input;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Input.js
// module id = 112
// module chunks = 0 1